import { Injectable } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { getComponentViewByInstance } from '@angular/core/src/render3/context_discovery';
import { BehaviorSubject } from 'rxjs';
import { DataAccessService } from '../../shared/services/dataaccess.service';




export class Migration{
  MigrationApplicationID: number;
  StudentID: number;
  ExamInstanceID: number;
  CourseID:number;
  CoursePartID: number;
  BranchID: number;
  ClassID:number;
  CollegeToMigrate:string;
  UniversityToMigrate:string;
  CollegeToMigrate1:boolean;
  UniversityToMigrate1:boolean;
  MigrationApplicationNO:number;
  MigrationApplicationDate:string;
  MigrationApplicationFees:number;
  MigrationApplicationFeesReceivedDate:string;
  MigrationApplicationDDNO:string;
  MigrationApplicationBankName:string;
  MigrationApplicationDDDate:string;
  FormNo:string;
  PaymentMode:string;
    DeleteFlag: string;
  CreatedLoginID: number;
  UpdatedLoginID: number;
  
}
@Injectable({
  providedIn: 'root'
})
export class MigrationService {
    
    constructor(
      private dataService: DataAccessService) {
    }
 
    public GetTransferredMigrationData(CourseID,CollegeID) {debugger
      this.dataService.setControllerName = '/PortalCollegeChange/';
      this.dataService.setMethodName = 'GetCollegeForCollegeChange?CourseID='+CourseID+'&CollegeID='+CollegeID; 
      return this.dataService.getAll<Migration[]>()
    }

    public save(data) {debugger
      this.dataService.setControllerName = '/PortalStudentMigrationApplication/';
      this.dataService.setMethodName = 'PostInsertPortalStudentMigrationApplicationNEW'; 
      return this.dataService.add<Migration[]>(data) 
    }

    public GetDataForMigrationChangeList(StudentID,ExamInstanceID,AcademicInstanceID,CoursePartID) {debugger
      this.dataService.setControllerName = '/PortalStudentMigrationApplication/';
      this.dataService.setMethodName = 'GetDataForMigrationChangeList?StudentID='+ StudentID+'&ExamInstanceID='+ExamInstanceID+'&AcademicInstanceID='+AcademicInstanceID+'&CoursePartID='+CoursePartID; // setting method name from API controller.
      return this.dataService.getAll<Migration[]>()
    }

    public CheckMigrationStatusForNewRequest(StudentID,ExamInstanceID,CoursePartID) {debugger
      this.dataService.setControllerName = '/PortalStudentMigrationApplication/';
      this.dataService.setMethodName = 'CheckMigrationStatusForNewRequest?StudentID='+ StudentID+'&ExamInstanceID='+ExamInstanceID+'&CoursePartID='+CoursePartID; // setting method name from API controller.
      return this.dataService.getAll<Migration[]>()
    }

    public GetUpdatePaymentStatusForMigration(merchantTxnNo,ExamInstanceID,ApplicationNO,StudentID) {debugger
      this.dataService.setControllerName = '/Payment/';
      this.dataService.setMethodName = 'GetUpdatePaymentStatusForMigration?merchantTxnNo='+ merchantTxnNo + '&ExamInstanceID='+ExamInstanceID+'&ApplicationNO='+ApplicationNO +'&StudentID='+StudentID; // setting method name from API controller.
      return this.dataService.getAll<Migration[]>()
    }
    public CancelMigrationApplication(RequestID,StudentID,AcademicInstanceID,ResultQueryCode) {
      this.dataService.setControllerName = '/PortalStudentMigrationApplication/';
      this.dataService.setMethodName = 'CancelMigrationApplication?RequestID='+RequestID+'&StudentID='+StudentID+'&AcademicInstanceID='+AcademicInstanceID+'&ResultQueryCode='+ResultQueryCode+'';
      return this.dataService.getAll<Migration[]>()
    }

    public GetClassIDByStudentID(StudentID,ExamInstanceID,CoursePartID ,BranchID) {
      this.dataService.setControllerName = '/PortalStudentMigrationApplication/';
      this.dataService.setMethodName = 'GetClassIDByStudentID?StudentID='+StudentID+'&ExamInstanceID='+ExamInstanceID+'&CoursePartID='+CoursePartID+'&BranchID='+BranchID; // setting method name from API controller.
      return this.dataService.getAll<Migration[]>()
    }
    public GetDocumentPathForMigration(ApplicationNO,ExamInstanceID) {
      this.dataService.setControllerName = '/PortalStudentMigrationApplication/';
      this.dataService.setMethodName = 'GetDocumentPathForMigration?ApplicationNO='+ApplicationNO+'&ExamInstanceID='+ExamInstanceID; // setting method name from API controller.
      return this.dataService.getAll<Migration[]>()
    }
}
